import { put, takeEvery } from "redux-saga/effects";

import ResultService from "../../services/result";
import {
  getResultStart,
  getResultSuccess,
  getResultFailure
} from "../../redux/results";
import { showErrorMessage } from "../../../redux-saga/redux/toast";

function* resultWatcher() {
  yield takeEvery(getResultStart.type, resultWorker);
}

function* resultWorker(action) {
  try {
    const { data, error } = yield ResultService.getResult(action.payload);
    if (data) {
      yield put(getResultSuccess(data));
    }
    if (error) {
      yield put(showErrorMessage({ msg: error }));
      yield put(getResultFailure());
    }
  } catch (error) {
    yield put(getResultFailure());
    yield put(showErrorMessage({ msg: error }));
  }
}

export default resultWatcher;
